<template>
  <div>
      <el-image src="static/img/images07.png" class="el-image-head"/>
    <div class="div-content" v-show="showMain">
      <div class="div-content-title">
        <label class="label-title">企业动态</label>
      </div>
      <el-row>
        <el-col :span="8">
          <el-card body-style="padding:0" class="el-card-time"
                   @click.native="chooseChild(0)">
              <el-image class="el-image-time" src="static/img/yeqi19.png"/>
              <div class="div-time">
                <label class="label-time">2021/03/08</label>
              </div>
            <div class="div-name">
              <label class="label-content">2021年妇女节</label>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card body-style="padding:0;" class="el-card-time"
                   @click.native="chooseChild(1)">
            <el-image class="el-image-time" src="static/img/yeqi22.png"/>
            <div class="div-time">
              <label class="label-time">2021/02/26</label>
            </div>
            <div class="div-name">
              <label class="label-content">2021年元宵节</label>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card body-style="padding:0" class="el-card-time"
                   @click.native="chooseChild(2)">
            <el-image class="el-image-time" src="static/img/qiye16.png"/>
            <div class="div-time">
              <label class="label-time">2021/01/01</label>
            </div>
            <div class="div-name">
              <label class="label-content">2021年迎新年会</label>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="el-row2-time">
        <el-col :span="8">
          <el-card body-style="padding:0" class="el-card-time"
                   @click.native="chooseChild(3)">
            <el-image class="el-image-time" src="static/img/qiye14.png"/>
            <div class="div-time">
              <label class="label-time">2020/12/24</label>
            </div>
            <div class="div-name">
              <label class="label-content">2020年圣诞节</label>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card body-style="padding:0;" class="el-card-time"
                   @click.native="chooseChild(4)">
            <el-image class="el-image-time" src="static/img/qiye01.png"/>
            <div class="div-time">
              <label class="label-time">2020/06/07</label>
            </div>
            <div class="div-name">
              <label class="label-content">2020年度慧源创新篮球赛</label>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card body-style="padding:0" class="el-card-time"
                   @click.native="chooseChild(5)"
                    >
            <el-image class="el-image-time" src="static/img/images05.png"/>
            <div class="div-time">
              <label class="label-time">2020/01/01</label>
            </div>
            <div class="div-name">
              <label class="label-content">2020年迎新年会</label>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="div-item" v-show="showChild">
      <div class="div-content-item">
        <el-breadcrumb separator=">>">
          <el-breadcrumb-item @click.native="returnParent" >
            <el-link class="item-head" :underline="false">企业动态</el-link></el-breadcrumb-item>
          <el-breadcrumb-item class="item-name">{{childSrc[childIndex].name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="div-item-title">
        <label class="label-content-item">{{childSrc[childIndex].name}}</label>
      </div>
      <div class="div-item-time">
        <label class="label-time">{{childSrc[childIndex].time}}</label>
      </div>
      <div class="div-item-img">
        <el-image :src="childSrc[childIndex].img0" class="image-child"/>
      </div>
      <div class="div-item-img">
        <el-image :src="childSrc[childIndex].img1" class="image-child"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dynamic',
  data () {
    return {
      active: false,
      showMain: true,
      showChild: false,
      childIndex: 0,
      childSrc: [
        {name: '2021年妇女节', time: '2021/03/08', img0: 'static/img/yeqi19.png', img1: 'static/img/yeqi17.png'},
        {name: '2021年元宵节', time: '2021/02/26', img0: 'static/img/yeqi22.png', img1: 'static/img/yeqi20.png'},
        {name: '2021年迎新年会', time: '2021/01/01', img0: 'static/img/qiye16.png', img1: 'static/img/qiye15.png'},
        {name: '2020年圣诞节', time: '2020/12/24', img0: 'static/img/qiye14.png', img1: 'static/img/qiye17.png'},
        {name: '2020年慧源创新篮球赛', time: '2020/06/07', img0: 'static/img/qiye01.png', img1: 'static/img/qiye02.png'},
        {name: '2020年迎新年会', time: '2020/01/01', img0: 'static/img/images05.png', img1: 'static/img/qiye11.png'}
      ]
    }
  },
  activated () {
    this.showMain = true
    this.showChild = false
  },
  methods: {
    chooseChild (index) {
      this.childIndex = index
      this.showMain = false
      this.showChild = true
    },
    returnParent () {
      this.showMain = true
      this.showChild = false
    }
  }
}
</script>

<style scoped>
.el-image-head{
  height: 541px;
  width: 100%;
}
.div-content{
  width: 60%;
  margin-top: 80px;
  margin-left: 20%;
  padding-bottom: 200px;
}
.label-title{
  font-size: 26px;
  color: #FFB400;
  padding-bottom: 20px;
}
.div-content-title{
  margin-bottom: 20px;
}
.div-time{
  margin-top: 4px;
  margin-left: 10px;
}
.label-time{
  color: #B1B1B1;
  font-size: 16px;
}
.div-name{
  margin-bottom: 10px;
  margin-left: 10px;
}
.label-content{
  font-size: 16px;
}
.el-image-time{
  width: 360px;
  height: 270px;
}
.el-card-time{
  width: 360px;
  height: 330px;
  background: white;
  cursor: pointer;
}
.el-card-time:hover{
  background: #FFB400;
  color: white;
}

.el-card-time:hover label {
  color: white;
}

.el-row2-time{
  margin-top: 20px;
}
.div-item{
  width: 60%;
  margin-top: 60px;
  margin-left: 20%;
  padding-bottom: 200px;
}

.item-head{
  cursor: pointer;
  font-size: 20px;
  font-weight: normal;
}
.item-head:hover {
  color: #FFB400;
}
.item-name{
  font-size: 20px;
}
.div-content-item{
  float: right;
  padding-bottom: 40px;
}
.div-item-title{
  padding-top:40px;
}
.div-item-time{
  padding-bottom: 20px;
}
.label-content-item{
  color: #FFB400;
  font-size: 26px;
}
.image-child{
  width: 1080px;
  height: 720px;
}
.div-item-img{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dynamic.vue